// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "dd[data-v-335c4a84]{font-weight:bolder}.container[data-v-335c4a84]{display:flex;flex-grow:0;flex-shrink:0;box-sizing:border-box}.msg[data-v-335c4a84]{margin:5px}.select-panel[data-v-335c4a84]{height:0;z-index:999}.select-item[data-v-335c4a84]{z-index:999;margin:1px;padding:2px;background:#fff;opacity:.8}", ""]);
// Exports
module.exports = exports;
